import Swiper from "swiper11";
import { Navigation, Pagination, Autoplay, EffectFade } from "swiper11/modules";
import { globalSearch, initSearch, fixedsHeader, mainInit } from "@common/utils/initUtils";
import { ImportBundle, lazyLoad } from "@common/utils/utils";

const common = () => {
  lazyLoad();
  ImportBundle({ type: "js", onlyIndex: true }, [
    {
      src: "https://static.yigetechcms.com/public/js/wow.min.js",
      fn: () => {
        new WOW().init();
      },
    },
  ]);
  ImportBundle({ type: "css", onlyIndex: true }, [
    "https://static.yigetechcms.com/public/css/swiper/swiper-bundle@11.2.8.min.css",
    "https://static.yigetechcms.com/public/css/animate.min.css",
  ]);
};

const initEvent = () => {
  fixedsHeader("header-15");
  initSearch(".header-search form", ".header-search .toggle");
  globalSearch();
};

const initSwiper = () => {
  new Swiper(".index-15-banner .swiper", {
    modules: [Navigation, Pagination, Autoplay, EffectFade],
    // slidesPerView: 1,
    speed: 1500,
    autoplay: {
      disableOnInteraction: false,
      delay: 5500,
    },
    loop: true,
    navigation: {
      nextEl: ".index-15-banner .next",
      prevEl: ".index-15-banner .prev",
    },
    pagination: {
      el: ".index-15-banner .custom-swiper-pagination",
      clickable: true,
    },
  });

  new Swiper(`.index_partner_swiper.swiper`, {
    modules: [Navigation, Pagination, Autoplay, EffectFade],
    slidesPerView: 3,
    speed: 1500,
    // autoplay: {
    //   delay: 5000,
    // },
    breakpoints: {
      320: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      620: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
      1400: {
        slidesPerView: 5,
        spaceBetween: 20,
      },
    },
    loop: true,
  });

  new Swiper(".index_news_swiper.swiper", {
    modules: [Navigation, Pagination, Autoplay, EffectFade],
    slidesPerView: 2,
    spaceBetween: 30,
    speed: 1500,
    // autoplay: {
    //   delay: 5000,
    // },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      620: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1366: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
    },
    loop: true,
  });

  new Swiper(".index_partner_swiper2.swiper", {
    modules: [Navigation, Pagination, Autoplay, EffectFade],
    slidesPerView: 2,
    spaceBetween: 30,
    speed: 1500,
    // autoplay: {
    //   delay: 5000,
    // },
    breakpoints: {
      320: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      620: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
      1400: {
        slidesPerView: 5,
        spaceBetween: 20,
      },
    },
    loop: true,
  });

  new Swiper(`.index_product_swiper.swiper`, {
    modules: [Navigation, Pagination, Autoplay, EffectFade],
    // slidesPerView: 1,
    speed: 500,
    // autoplay: {
    //   disableOnInteraction: false,
    //   delay: 5500,
    // },
    pagination: {
      el: `.index_product_swiper .custom-swiper-pagination`,
      clickable: true,
    },
    touchRatio: 0,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    on: {
      init(swiper) {
        if (swiper.slides.length) {
          const list = $(".index_product_page .list");
          if (!list.length) return;
          swiper.slides.forEach((slide, index) => {
            const $itemDOM = $(`<div class="item ${index === 0 ? "active" : ""}">${index + 1}</div>`);
            $itemDOM.on("click", (e) => {
              const index = $(e.currentTarget).index();
              swiper.slideTo(index);
              $(e.currentTarget).addClass("active").siblings().removeClass("active");
            });
            list.append($itemDOM);
          });
        }
      },
    },
  });
  new Swiper(`.index_applications_swiper.swiper`, {
    modules: [Navigation, Pagination, Autoplay, EffectFade],
    slidesPerView: 3,
    spaceBetween: 35, //间隔
    speed: 1500,
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 15,
      },
      620: {
        slidesPerView: 1,
        spaceBetween: 15,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      1024: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      1366: {
        slidesPerView: 3,
        spaceBetween: 35,
      },
    },
  });

  new Swiper(`.index_news_swiper.swiper`, {
    modules: [Navigation, Pagination, Autoplay, EffectFade],
    slidesPerView: 3,
    spaceBetween: 35, //间隔
    speed: 500,
    navigation: {
      nextEl: `.index_news_swiper .next`,
      prevEl: `.index_news_swiper .prev`,
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 15,
      },
      620: {
        slidesPerView: 1,
        spaceBetween: 15,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      1024: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      1366: {
        slidesPerView: 3,
        spaceBetween: 35,
      },
    },
  });
};

mainInit([common, initEvent, initSwiper]);
